var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPaymentMethodLightcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6495 10.9584C16.6495 13.753 14.4164 16.0184 11.6618 16.0184C8.90715 16.0184 6.67407 13.753 6.67407 10.9584C6.67407 8.16388 8.90715 5.89844 11.6618 5.89844C14.4164 5.89844 16.6495 8.16388 16.6495 10.9584ZM10.4454 10.9585L11.1751 8.18164H12.7567L12.2092 10.3415L12.9392 10.033L12.7567 10.7116L12.0266 10.9585L11.6618 12.3161H14.2774L14.0341 13.3033H9.83689L10.2628 11.6372L9.65459 11.884L9.83689 11.2054L10.4454 10.9585Z",
    fill: "#A5A8A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodLightcoin);
export default __webpack_public_path__ + "static/media/icon_payment_method_lightcoin.1317f862397f9e4682cbd311e201234e.svg";
export { ForwardRef as ReactComponent };